import { createContext } from 'react';

export type Theme = 'light' | 'dark';

export type ThemeContextValue = {
  theme: Theme;
  toggleTheme: () => void;
  setTheme: (theme: Theme) => void;
};

/**
 * The theme context object. Lives in its own module so the ThemeProvider
 * file can export only the component (react-refresh/only-export-components).
 * Consumers should not import this directly; use the `useTheme` hook from
 * `./use-theme`.
 */
export const ThemeContext = createContext<ThemeContextValue | null>(null);
